<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap pb-5>
                        <v-flex xs12 pb-5>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex xs12 md6>
                            <h1>Установить запреты</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap pb-5>
                        <v-flex xs12 sm6 md3 lg3>
                            <v-btn @click="newTemplate(false)"
                                   class="submit-button block">Создать шаблон
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg3>
                            <v-btn @click="newTemplate(true)"
                                   class="submit-button block">Создать шаблон Е-Гарант
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-card>
                                <v-toolbar flat>
                                    <v-toolbar-title>Готовые шаблоны</v-toolbar-title>
                                </v-toolbar>
                                <v-tabs
                                    v-model="tab"
                                >
                                    <v-tab v-for="item in tabs" :key="item.id">
                                        {{ item.name }}
                                    </v-tab>
                                    <v-tab-item v-for="item in tabs" :key="item.id">
                                        <v-list v-if="itemsList.length > 0">
                                            <template v-for="(template,index) in itemsList">
                                                <v-divider v-if="index > 0"/>
                                                <v-list-tile
                                                    :key="template.id"
                                                    @click=""
                                                >
                                                    <v-list-tile-content
                                                        @click="editTemplate(template.id)"
                                                    >
                                                        <v-list-tile-title v-html="template.name"></v-list-tile-title>
                                                    </v-list-tile-content>

                                                    <v-list-tile-action>
                                                        <v-layout>
                                                            <v-btn icon
                                                                   @click="copyTemplate(template.id)"
                                                            >
                                                                <v-icon color="green" lighten-1>content_copy</v-icon>
                                                            </v-btn>

                                                            <v-btn icon
                                                                   @click="removeTemplate(template.id)"
                                                            >
                                                                <v-icon color="red" lighten-1>delete_forever</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                            </template>
                                        </v-list>
                                        <h4 v-if="itemsList.length === 0" class="centered pt-5">
                                            Не найдено ни одного шаблона
                                        </h4>
                                    </v-tab-item>
                                </v-tabs>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: 'Segmentations',
    props: ['templates', 'egarantTemplates'],
    data: () => ({
        templatesList: [],
        egarantTemplatesList: [],
        tab: 0,
        tabs: [
            { id: 0, name: 'Обычные' },
            { id: 1, name: 'Е-Гарант' }
        ]
    }),
    computed: {
        itemsList() {
            if (this.tab === 0) {
                return this.templatesList;
            }
            if (this.tab === 1) {
                return this.egarantTemplatesList;
            }
            return [];
        }
    },
    created() {
        if (this.templates) {
            this.templatesList = JSON.parse(window.atob(this.templates));
        }
        if (this.egarantTemplates) {
            this.egarantTemplatesList = JSON.parse(window.atob(this.egarantTemplates));
        }
    },
    methods: {
        newTemplate(isEgarant) {
            window.location.href = '/segmentation' + (isEgarant ? '?isEgarant=true' : '');
        },
        editTemplate(id) {
            if (id) {
                window.location.href = '/segmentation/' + id;
            } else {
                PNotify.error('Шаблон не найден.');
            }
        },
        removeTemplate(id) {
            if (id) {
                let that = this;
                axios.delete('/segmentation/' + id + '/delete')
                    .then(response => {
                        that.templatesList = that.templatesList.filter(function(item) {
                            return item.id !== id;
                        });
                        PNotify.success('Шаблон был удалён.');
                    })
                .catch(error => {
                    PNotify.error('При удалении шаблона возникла ошибка.');
                    console.log(error);
                });
            }
        },
        copyTemplate(id) {
            if (id) {
                axios.post('/segmentation/copy', { id: id })
                    .then(response => {
                        window.location.href = '/segmentation/' + response.data.templateId;
                        PNotify.success('Шаблон был добавлен. Сейчас на него перенаправим');
                    })
                    .catch(error => {
                        PNotify.error('При создании копии шаблона возникла ошибка.');
                        console.log(error);
                    });
            }
        }
    }
}
</script>

<style scoped>
    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 56px;
        background-color: #00ba57 !important;;
        text-align: center;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0 5px;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 16px 60px 0;
        line-height: 1.1;
    }

    /deep/ .v-toolbar__title {
        font-family: 'SFPro';
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 38px !important;
    }

    /deep/ .v-toolbar__content {
        padding-left: 0px !important;
    }

    /deep/ h1 {
        font-size: 48px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3, h4 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    /deep/ h4 {
        font-size: 16px;
    }

    .centered {
        text-align: center;
    }

    @media  screen and (max-width: 479px) {
        .v-toolbar__title {
            font-size: 24px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/Segmentations.vue